import styled from "styled-components";

export const SortWrapper = styled.span`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

export const Label = styled.span`
  margin-right: 6px;
`;

export const Icons = styled.span`
  display: flex;
  align-items: center;

  svg + svg {
    margin-left: -4px;
  }
`;